export class BrmDinErrors {
  public static INVALID_DIN_COMBO = 'din000';
}
